export const model = {
    id: null,
    name: '',
    amount: 0,
    description: '',
    created_at: '',
    updated_at: ''
};
